// extracted by mini-css-extract-plugin
export default {"button":"Oo-z","reviewSort":"Po-z"};